export default {"src":"/_next/static/media/fin-times.6c6502ad.svg","height":13,"width":158,"blurWidth":0,"blurHeight":0};